import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import { Link } from 'react-router-dom'

const t = buildTranslate(
  'locations.location_list.location_detail.menu_errors_crosslink'
)

// Closes the error-banner section on the location detail page (Figma
// 5:1028): when the BE reports that Toast shared-menu errors affect this
// location (menu_error_count > 0), those errors have been moved off this
// page onto the Menu Errors page, so we point the operator there instead
// of rendering the (now-removed) per-location menu errors. Rendered only
// when the count is positive — the caller guards on that. (DATA-5331)
const MENU_ERRORS_PATH = '/pos_configurations'

const MenuErrorsCrossLink = () => {
  const [css] = useStyletron()
  return (
    <div
      className={`d-flex align-items-center p-m mb-xl ${css({
        backgroundColor: palette.eggYolk10,
        borderRadius: '4px',
      })}`}
    >
      {/* Decorative — the message text states the warning. */}
      <i
        className={`fa fa-exclamation-triangle mr-m ${css({
          color: palette.eggYolk50,
          fontSize: '20px',
        })}`}
        aria-hidden="true"
      />
      <p className={`body-text-4 mb-0 ${css({ color: palette.grey70 })}`}>
        {t('message')}{' '}
        <Link
          to={MENU_ERRORS_PATH}
          className={css({ color: palette.belizeHole })}
        >
          {t('link')}
        </Link>
      </p>
    </div>
  )
}

export default MenuErrorsCrossLink
